/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from 'react';
import {
  VegaFlex,
  VegaFont,
  VegaBox,
  VegaButtonCircle
} from '@heartlandone/vega-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { dateTimeFormat } from 'Chores/utils';
import MSG_LOGO from '../../Public/Image/msg-logo.svg';

const MessageDetail = ({ unTriggeredMessage, deleteMessage }) => {
  const messageDetail = useSelector((state) => state.message.messageDetail);

  const onClose = () => {
    unTriggeredMessage(messageDetail);
  };

  const deleteMessageByDetail = () => {
    deleteMessage(messageDetail);
  };

  const formattedCreationTime = (creationTime) => dateTimeFormat(creationTime, 'DD MMM YYYY HH:mm');

  return (
    <>
      <VegaBox padding="size-24" backgroundColor="bg-primary" flexGrow={2} flexBasis={0}>
        <VegaFlex
          direction="col"
          alignItems="stretch"
          justifyContent="start"
          gap="size-12"
        >
          <VegaFlex alignItems="center" justifyContent="space-between">
            <VegaFont
              color="text-sidebar-link-hover"
              variant="font-field-label-lg"
              style={{ display: 'block', verticalAlign: 'center', alignSelf: 'center' }}
              textAlign="left"
            >
              {messageDetail.subject}
            </VegaFont>
            <VegaButtonCircle
              size="default"
              disabled="false"
              danger="false"
              variant="icon-only"
              icon="fas fa-xmark-large"
              iconColor="text-sidebar-link-hover"
              onVegaClick={onClose}
            ></VegaButtonCircle>
          </VegaFlex>

          <VegaFlex
            direction="row"
            alignItems="center"
            justifyContent="start"
            gap="size-12"
          >
            <VegaBox>
              <img
                height="60"
                width="60"
                src={MSG_LOGO}
              />
            </VegaBox>
            <VegaBox flexGrow={10} flexBasis={0}>
              <VegaFlex
                direction="row"
                alignItems="stretch"
                justifyContent="space-between"
                gap="size-4"
              >
                <VegaFlex
                  direction="col"
                  alignItems="stretch"
                  justifyContent="center"
                  gap="size-4"
                >
                  <VegaFont
                    color="text-sidebar-link-hover"
                    variant="font-field-label-lg"
                    style={{ display: 'block', verticalAlign: 'top', alignSelf: 'stretch' }}
                    textAlign="left"
                  >
                    {messageDetail.fromName}
                  </VegaFont>

                  <VegaFont
                      color="text-secondary"
                      variant="font-field-label-sm"
                      style={{ display: 'block', verticalAlign: 'top', alignSelf: 'stretch' }}
                      textAlign="left"
                    >
                    {formattedCreationTime(messageDetail.creationTime)}
                  </VegaFont>
                </VegaFlex>
                <VegaButtonCircle
                  size="default"
                  disabled="false"
                  danger="false"
                  variant="icon-only"
                  icon="far fa-trash-can"
                  iconColor="text-danger-link-active"
                  onVegaClick={deleteMessageByDetail}
                ></VegaButtonCircle>
              </VegaFlex>
            </VegaBox>

          </VegaFlex>
          <div
            style={{ whiteSpace: 'wrap' }}
            dangerouslySetInnerHTML={{
              __html: messageDetail.body
            }}
          ></div>
        </VegaFlex>
      </VegaBox>
    </>
  );
};

MessageDetail.propTypes = {
  unTriggeredMessage: PropTypes.func,
  deleteMessage: PropTypes.func
};

export default MessageDetail;
